import { OrganizationCode } from 'merchandising-sdk';

export const environment = {
  production: false,
  organization: OrganizationCode.AS,
  is_online: true,
  assets_url: 'https://stmerchandisingas.blob.core.windows.net/as-assets',
  local_db_name: '',
  azure_blob_sas_url: ``,
  azure_container: ``,
  azure_container_uploads: ``
};